import { v4, replace, resolvePromiseWithDelay } from "@smart/itops-utils-basic";

import {
  getLocalSmokeballAppContext,
  setLocalSmokeballAppContext,
} from "./utils";
import {
  AddRoleRequest,
  LocalSmokeballAppContext,
  Role,
  UpdateRoleRequest,
} from "../types";

export const useRoles = () => ({
  get: () =>
    resolvePromiseWithDelay({
      roles: getLocalSmokeballAppContext()?.roles as Role[],
      versionId: "",
    }),
  add: ({ contactId, name }: AddRoleRequest) => {
    const localContext = getLocalSmokeballAppContext();
    const addedRole: Role = {
      id: v4(),
      versionId: v4(),
      contactId,
      representativeIds: [],
      name,
      isClient: true,
      isOtherSide: false,
    };
    const updatedContext = {
      ...localContext,
      roles: [...(localContext?.roles || []), addedRole],
    } as LocalSmokeballAppContext;
    setLocalSmokeballAppContext(updatedContext);

    return resolvePromiseWithDelay(addedRole);
  },
  update: ({ contactId, id }: UpdateRoleRequest) => {
    const localContext = getLocalSmokeballAppContext();
    const updatedRole = {
      ...localContext?.roles.find((role) => role.id === id),
      contactId,
    } as Role;
    const updatedContext = {
      ...localContext,
      roles:
        localContext?.roles &&
        replace(localContext.roles, (r) => r.id === id, updatedRole),
    } as LocalSmokeballAppContext;
    setLocalSmokeballAppContext(updatedContext);

    return resolvePromiseWithDelay(updatedRole);
  },
});
